import { ValidGuard } from './authentication/guards/valid.guard';
import { NgModule, InjectionToken } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { AccountDetailComponent } from './account-detail/account-detail.component';
import { VnetPeeringComponent } from './cloud-subscription/components/vnet-peering/components/vnet-peering/vnet-peering.component';
import { CrossAccountVnetPeeringComponent } from './cloud-subscription/components/vnet-peering/components/cross-account-peering/cross-account-peering.component';
import { EnvironmentViewSingleComponent } from './cloud-subscription/components/edit-environment/environment-view-single/environment-view-single.component';
import { EditEnvironmentComponent } from './cloud-subscription/components/edit-environment/edit-environment/edit-environment.component';
import { AvailablePlansComponent } from './subscription-plans/available-plans/savailable-plans.component';
import { AuthGuard } from './authentication/guards/auth.guard';
import { NewquotationComponent } from './paid-subscription/components/create-quotation/quotationforclient/quotations/newquotation/newquotation.component';
import { QuotationpreviewComponent } from './paid-subscription/components/create-quotation/quotationforclient/quotations/quotationpreview/quotationpreview.component';
import { BuyNcacheComponent } from './paid-subscription/components/buy-ncache/buy-ncache.component';
import { NonHostedPreviewquotationComponent } from './paid-subscription/components/create-quotation/quotationforclient/nonhosted/previewquotation/previewquotation.component';
import { RestrictionGuard } from './guards/restriction.guard';
import { GuideComponent } from './cloud-subscription/components/edit-environment/environment-view-single/guide/guide.component';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

const routes: Routes = [

  {
    path: 'newquotation',
    canActivate: [AuthGuard],
    component: BuyNcacheComponent,
  },
  {
    path: 'createquotation',
    canActivate: [AuthGuard],
    component: NewquotationComponent,
  },
   {
    path: 'previewquotation',
    canActivate: [ValidGuard,AuthGuard],
     component: QuotationpreviewComponent,
   },
   {
    path:'nonhosted/preview',
    canActivate:[ValidGuard,AuthGuard],
    component:NonHostedPreviewquotationComponent
   },

  {
    path: 'subscription',
    loadChildren: () =>
      import('./cloud-subscription/cloud-subscription.module').then(
        (m) => m.CloudSubscriptionModule
      ),
    data: {
      breadcrumbStopNav: true,
    },
  },
  {
    path: 'buy',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./paid-subscription/paid-subscription.module').then(
        (m) => m.PaidSubscriptionModule
      ),
    data: {
      breadcrumbStopNav: true,
    },
  },
  {
    path: 'account',
    data: {
      browserTitle: 'Account Settings',
    },
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: AccountDetailComponent,
        data: {
          breadcrumb: 'Account Settings',
        },
      },
    ],
  },
  {
    path: 'subscription/available_plans',
    canActivate:[AuthGuard],
    component: AvailablePlansComponent,
    data: {
      breadcrumb: 'Choose Plan',
      breadcrumbStopNav: true,
      browserTitle: 'Choose a Plan'
    }
  },
  {
    path: 'subscription/peering',
    component: VnetPeeringComponent,
  },
  {
    path: 'subscription/edit_environment',
    component: EnvironmentViewSingleComponent,
  },
  {
    path: 'addserver',
    component: EditEnvironmentComponent,
  },  
  {
    path: 'guide',
    component: GuideComponent,
  }, 
  {
    path: 'subscription/configure/new',
    loadChildren: () =>
      import(
        './cloud-subscription/components/configure-environment/configure-environment-test.module'
      ).then((m) => m.ConfigureEnvironmentTestModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    {
      provide: externalUrlProvider,
      useValue: (route: ActivatedRouteSnapshot) => {
        const externalUrl = route.paramMap.get('externalUrl');
        window.open(externalUrl, '_self');
      },
    },
  ],
})
export class AppRoutingModule {}
